export default "__VITE_ASSET__0o7yTr9U__"